var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "url(#pattern0_180_1298)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_180_1298",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_180_1298",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_180_1298",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAA01JREFUeAHtnUFuFEEMRXMBgoQQdwobBCSHDDeCZdggcQijisgoY8bV89sO44KXTcZV9i/7/VTPKIvk6oovCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQ+A8ImNl7M/tufGUJDIY36R8ZzMj6cFT/UGHIkSJBjgCG5PiVV2NIOdKcIIbk+JVXY0g50pwghuT4lVdjSDnSnCCG5PiVV2NIOdKcIIbk+JVXr27I+P3PrZm9yg4yNMzso5l9LacsCGbnuBLOqk4dZrxJD+AEhuYlfz/n2tHDasqC3q3e7XkVZnYn9FGael6Hk6zSbjSx9GMqGsvMrrVW6rKjns5er2tFVnpJQ17L3RQVnA0+SizqY4/Mp6in7LqZfd7TUEVNtvdLvqmPT0Mv9ab+rQLuHo2VDRnzjk9a4w34OjvI7/eNcTMuZsYYKDvHJW/Inh/A9jUY0swiDMGQZgSatcMNwZBmBJq1ww3BkGYEmrXDDcGQZgSatcMNwZBmBJq1ww3BkGYEmrXDDcGQZgSatcMNwZBmBJq1ww3BkGYEmrXDDcGQZgSatcMNmRtyb2Zf5ilHu2r+UfEIMOQPJIeFn2b2zszemtmPw2r8Qs0/qYQhJ7E8Lt49wTGzD3HaYUfNPxQ+f/F05u7vz8X+odf3HsjGo0vND1H5c+U4VF534/HR40FMHl1q/pSMP1eOp+prbh4ePR5G8OhS86dU/JlyPFVfeNOD2BpFzY/0vI4cR8Krr3sQW/Oo+ZGe15HjSHj1dQ9iax41P9LzOnIcCa++7kFszaPmR3peR44j4dXXPYitedT8SM/ryHEkvPq6B7E1j5of6XkdOY6EWd9HQDbAF+w7lqqIgOcrx5HwqusygI0ClcOG3Pa2emD3/O2JtQx1Xk39RLZ6YPf8EyOmltR5U4eNYvXA7vlpIE5AndeV66F6IPlzAroDrmIuz65KwOHVQ/VA8ucEdAdcxVyeXZWAw6uH6oHkzwnoDriKuTy7KgGHVw/VA8mfE9AdcBVzeXZVAg6vHqoHkj8noDvgKuby7KoEHF49vOQfHVaHXSC/5J+C3ZjZwwLDdm9xMMz/2zz9TlEBAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACf53AL8q6Bks1QhOPAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.f7fabdae5d72d9ffdc4bdbeb392492aa.svg";
export { ForwardRef as ReactComponent };